import { useState, useEffect } from 'react';

import YouTube from '~components/YouTube/Youtube';

type Props = { standardid: string; descriptionid: string; jsapi: boolean };

const VideoEmbed = ({ standardid, descriptionid, jsapi }: Props) => {
    const [standard, setStandard] = useState(true);

    let params: { controls: number; enablejsapi?: number; rel?: number } = {
        controls: 1,
    };

    if (jsapi) {
        params = {
            controls: 1,
            enablejsapi: 1,
            rel: 0,
        };
    }

    useEffect(() => {
        document.getElementById(`youtube_container`)?.addEventListener('click', loadYoutubeScript);
    }, []);

    const loadYoutubeScript = () => {
        const youtubeScript = document.getElementById('yt-script');
        if (!youtubeScript) {
            const newScriptTag = document.createElement('script');
            newScriptTag.src = 'https://www.youtube.com/iframe_api';
            newScriptTag.id = 'yt-script';
            newScriptTag.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(newScriptTag);
            document
                .getElementById(`youtube_container`)
                ?.removeEventListener('click', loadYoutubeScript);
        }
    };

    return (
        <div className="max-w-[500px] mb-8 print:hidden mx-auto" id="youtube_container">
            <YouTube videoId={standard ? standardid : descriptionid} params={params} />
            {descriptionid && (
                <button
                    className="inline-flex items-center text-link text-base md:text-lg"
                    type="button"
                    onClick={() => {
                        setStandard(!standard);
                    }}
                >
                    <i className="vf-btn-icon inline-block mr-2"></i>
                    <span>Watch {standard ? 'with' : 'without'} audio descriptions</span>
                </button>
            )}
        </div>
    );
};

export default VideoEmbed;
